// This file is auto-generated by @hey-api/openapi-ts
import { formDataBodySerializer } from './client';
import { client } from './client.gen';
export class BrandGuidelinesService {
    /**
     * Import guidelines from text files
     *
     *
     * Imports guidelines from text files (.txt, .md).
     *
     * A file that uses the structured format below is parsed as written, with no AI, and any mistake in
     * it is rejected with the file and guideline it was found in. A file with none of these fields is
     * read as free prose, and an LLM derives the guidelines from it.
     *
     * Each guideline block is separated by a blank line and must contain the following key-value pairs:
     * - Name: <guideline name>
     * - Description: <guideline description>
     * - Category: <category>
     *
     * Optional fields per block:
     * - Positive Example: <example text>
     * - Negative Example: <example text>
     *
     * The resulting guidelines are assigned to the provided ownership. Ownership information required:
     * - "workspaceId" with optional "projectId" and "folderId"
     *
     */
    static importGuidelines(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/import',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Generate brand guidelines from uploaded files
     *
     *
     * Analyzes uploaded image and PDF files using an LLM model to extract brand guidelines.
     *
     * The resulting guidelines are assigned to the provided ownership. Ownership information required:
     * - "workspaceId" with optional "projectId"
     *
     * Key features:
     * - Extracts guidelines from provided files using AI analysis
     * - Extracts positive and negative examples
     * - Supported formats: PNG, JPEG, PDF
     *
     * Note: This is an AI-assisted process and results should be carefully reviewed.
     *
     */
    static generateGuidelines(options) {
        return (options.client ?? client).post({
            ...formDataBodySerializer,
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/generate-from-file',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    /**
     * Generate brand guidelines from text input
     *
     *
     * Utilizes an LLM model to analyze provided text and generate brand guidelines.
     *
     * The resulting guidelines are assigned to the provided ownership. Ownership information required:
     * - "workspaceId" with optional "projectId"
     *
     * Key features:
     * - Extracts guidelines based on textual descriptions
     * - Analyzes tone, messaging style, and brand values
     * - Serves as a starting point for guideline creation
     * - Supports plain text input
     *
     * Note: This is an AI-assisted process and results should be carefully reviewed.
     *
     */
    static generateGuidelinesFromText(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/generate-from-text',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete multiple guidelines
     */
    static deleteGuidelines(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get guidelines by identifier
     */
    static getGuidelinesByType(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines',
            ...options
        });
    }
    /**
     * Create a new guideline
     */
    static createGuideline(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a guideline
     */
    static deleteGuideline(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/{guidelineId}',
            ...options
        });
    }
    /**
     * Get a single guideline
     */
    static getGuideline(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/{guidelineId}',
            ...options
        });
    }
    /**
     * Update guideline
     */
    static updateGuideline(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/{guidelineId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Create multiple guidelines at once
     */
    static createManyGuidelines(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/guidelines/bulk',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ExamplesService {
    /**
     * Add an example to a guideline
     */
    static addTextExample(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/examples',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Remove a single example from guideline
     */
    static removeExample(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/examples/{exampleId}',
            ...options
        });
    }
    /**
     * Update an example
     */
    static updateExample(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/examples/{exampleId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class FoldersService {
    /**
     * Get all folders for a workspace
     */
    static getFoldersByWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders',
            ...options
        });
    }
    /**
     * Create a new folder
     */
    static createFolder(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all folders with their guidelines for a workspace
     */
    static getFoldersWithGuidelines(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/with-guidelines',
            ...options
        });
    }
    /**
     * Export folder guidelines as a text file
     */
    static exportGuidelines(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/{folderId}/export',
            ...options
        });
    }
    /**
     * Delete a folder
     */
    static deleteFolder(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/{folderId}',
            ...options
        });
    }
    /**
     * Get a folder by ID
     */
    static getFolder(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/{folderId}',
            ...options
        });
    }
    /**
     * Update a folder
     */
    static updateFolder(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/{folderId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Resolve a folder id to its owning workspace and organization
     *
     * Accepts the internal folder id, regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/folders/{id}/resolve-workspace',
            ...options
        });
    }
}
export class BrandMediaService {
    /**
     * The media a caller may use
     *
     * Archived rows and expired licences never return, whatever was asked for. A market admits media tagged with it or tagged with none. briefScope=only makes media outside the brief absent rather than forbidden, which is what constrains an agent while leaving a person free to look past it. Cursor paginated: pass the previous page's nextCursor back as cursor to continue.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media',
            ...options
        });
    }
    /**
     * Add media to the library
     *
     * For assets the brand already holds. Upserts on the asset id, so adding the same file twice updates the row rather than duplicating it.
     */
    static create(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Which tags the scoped media carries
     *
     * Counted against the same scope the listing uses, so a count never promises a row the grid hides. A facet's own selections are dropped from its own counts, which is what lets a second value be added without the first collapsing the list.
     */
    static facets(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/tags',
            ...options
        });
    }
    /**
     * Retire media from the library
     *
     * Stamps archivedAt, which every read already filters on, so the media stops being offered without the bytes moving: a board that already placed the asset keeps rendering it. Adding the same asset again clears the stamp, so this is reversed by re-upload rather than by an undo. Media outside the workspace is left alone rather than refused, so a stale id in a selection cannot fail the whole call.
     */
    static archive(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/actions/archive',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Rename a tag value everywhere it is used
     *
     * Renaming onto a value the key already holds merges the two, leaving the survivor where the first of them sat. Keys written by image analysis are renamed like any other: ingestion only revisits rows that are missing something, so a described asset is not re-described and the new name stands. Archived media keeps its old value: it is out of the library until somebody uploads the file again.
     */
    static renameTagValue(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/tags/actions/rename',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Take a tag value off every asset carrying it
     *
     * A key whose last value goes is dropped rather than left empty, so the tag stops being offered at all. Not reversible, unlike retiring media: a tag exists only as long as something carries it. Refused for a key image analysis writes, since ingestion refills any such key it finds empty and the removal would come back on some assets and not others; rename the value instead, which reaches every one of them.
     */
    static removeTagValue(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/tags/actions/remove',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Set a picture's tags
     *
     * Normalised server-side, so a tag typed here and one written by ingest cannot drift apart. Keys the model owns are left as they are.
     */
    static setTags(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/{mediaId}/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Move a reviewed proposal into the library
     *
     * Carries the reviewed descriptions across unchanged. Classification and embeddings are left for ingestion to fill.
     */
    static promote(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/promote/{proposalId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Ingest media nothing has finished with
     *
     * Runs over rows missing a measurement, a description or an embedding, oldest first. Idempotent, so it doubles as the retry after a failed model call and the recovery after a restart drops queued work. A description already reviewed by a person is left alone; the classification around it still fills.
     */
    static ingest(options) {
        return (options?.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/ingest',
            ...options
        });
    }
    /**
     * The workspace's folder tree
     *
     * Flat, with each folder carrying what is filed directly in it and the unfiled count reported beside the list. Flat because a tree is one shape a caller might want and a table is another, and the parent ids build either. Cursor paginated: pass the previous page's nextCursor back as cursor to continue.
     */
    static folders(options) {
        return (options?.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders',
            ...options
        });
    }
    /**
     * Add a folder
     *
     * Nests under parentId when given. A parent in another workspace is refused rather than ignored, since creating it at the top would look like it worked.
     */
    static createFolder(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Mark folders as owned by a content board
     *
     * Sets the owner on folders that have none, and leaves any folder that already has one alone, so a rerun marks nothing.
     */
    static markBoardOwned(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders/actions/mark-board-owned',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a folder and everything under it
     *
     * Takes the folders beneath it too, so a tree is removed once rather than level by level. The media filed anywhere in that subtree is retired the way `actions/archive` retires it -- stamped rather than removed, so a board that already placed an asset keeps rendering it, and re-uploading the file brings it back. The folder rows themselves are removed for good: a folder is a label over the library, not the thing it holds.
     */
    static deleteFolder(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders/{folderId}',
            ...options
        });
    }
    /**
     * Rename a folder
     *
     * The slug is left alone: it is how a folder is addressed without walking its ancestors, so changing it on a rename would break any link that already used it.
     */
    static renameFolder(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders/{folderId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * File media into a folder
     *
     * A null folderId files the media out of every folder. Media outside the workspace is left alone rather than refused, so a stale id in a selection cannot fail the whole move.
     */
    static fileIntoFolder(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/folders/file',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Say which media a brief may draw on
     *
     * Idempotent, so re-reading a brief can resolve its scope again. The read side already exists: GET /brand-media with briefId and briefScope=only returns exactly these.
     */
    static link(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-media/briefs/{briefId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class BrandFontService {
    /**
     * The workspace's fonts
     *
     * Narrowable to folders, the same two parameters the media listing accepts, so one rail selection can ask both resources the same question. Cursor paginated: pass the previous page's nextCursor back as cursor to continue.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font',
            ...options
        });
    }
    /**
     * Add a font to the library
     *
     * For a font file already stored in assets-api. Upserts on the asset id, and otherwise on the same family, weight, style and filename, so adding the same font twice updates the row rather than duplicating it. Rejects an asset whose stored MIME type is not a font format.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Retire fonts from the library
     *
     * The bulk form of the single archive below, for a selection made across media and fonts at once. Fonts outside the workspace are left alone rather than refused, so a stale id in a selection cannot fail the whole call.
     */
    static archiveMany(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font/actions/archive',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Set a font's tags
     */
    static setTags(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font/{fontId}/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Replace a font's file
     *
     * For a font file already stored in assets-api. Keeps the font id, folder and tags, and overwrites everything the old file described about itself. 409 when another font in the library is already this file.
     */
    static replaceFile(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font/{fontId}/file',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Retire a font
     *
     * Soft delete, matching brand media: the row is kept, not removed.
     */
    static archive(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/brand-font/{fontId}/archive',
            ...options
        });
    }
}
export class MigrationService {
    /**
     * Get migration status
     */
    static getMigrationStatus(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/migrate-legacy-guidelines/status',
            ...options
        });
    }
    /**
     * Execute legacy guidelines migration
     */
    static migrateLegacyGuidelines(options) {
        return (options?.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/migrate-legacy-guidelines',
            ...options
        });
    }
}
